module.exports = __webpack_public_path__ + "c06d042dad9660297442cc1b5230d46d.png";